function setupCollectionTabs() {
  const tabContainers = document.querySelectorAll('.collection-tabs');

  tabContainers.forEach(container => {
    const tabButtons = container.querySelectorAll('.collection-tabs_header-item');
    const tabContents = container.querySelectorAll('.collection-tabs_product-container');

    tabContents.forEach(content => {
        const swiperEl = content.querySelector('.swiper');
        if (swiperEl) {
            new Swiper(swiperEl, {
            observer: true,
            observeParents: true,
            slidesPerView: 4,
            spaceBetween: 12,
            breakpoints: {
                1280: { slidesPerView: 4 },
                768: { slidesPerView: 3 },
                0: { slidesPerView: 1.5 },
            },
            });
        }
    });

    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            const index = button.getAttribute('index');

            tabButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            tabContents.forEach(content => {
            const contentIndex = content.getAttribute('index');
            if (contentIndex === index) {
                content.classList.add('active');
                content.classList.remove('inactive');
            } else {
                content.classList.remove('active');
                content.classList.add('inactive');
            }
            });
        });
    });
  });
}

function setupReviewsSwiper() {
    const reviewsContainer = document.querySelectorAll('.reviews-container');

    reviewsContainer.forEach(container => {
        const swiperContainer = container.querySelector('.swiper');

        if (swiperContainer) {
            new Swiper(swiperContainer, {
                slidesPerView: 1,
                loop: true,
                spaceBetween: 16,
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    }
                }
            });
        }
    })
}

/*
function setupMainBanner() {
    const swiperContainers = document.querySelectorAll('.main-banner_swiper');

    swiperContainers.forEach(container => {
        new Swiper(container, {
            loop: true,
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    });
}
*/
function setupMainBanner() {
    const swiperContainers = document.querySelectorAll('.main-banner_swiper');

    swiperContainers.forEach(container => {
        const slides = container.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;
        const isSingle = slideCount <= 1;

        new Swiper(container, {
            loop: !isSingle,
            allowTouchMove: !isSingle,
            grabCursor: !isSingle,
            autoHeight: true,

            pagination: isSingle ? false : {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },

            navigation: isSingle ? false : {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },

            autoplay: isSingle ? false : {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    });
}


function setupProductHighlight() {
    const swiperContainers = document.querySelectorAll('.product-highlight_swiper');

    swiperContainers.forEach(container => {
        new Swiper(container, {
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,            
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            spaceBetween: 20,
            breakpoints: {
                769: {
                    slidesPerView: 3,
                    allowTouchMove: false,
                },
            },
        });
    });
}

function setupStoresSwiper() {
    const swiperContainers = document.querySelectorAll('.stores-swiper');

    swiperContainers.forEach(container => {
        new Swiper(container, {
            centeredSlides: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            slidesPerView: 1.5,            
            loop: true,
            spaceBetween: 24,
            breakpoints: {
                769: {
                    slidesPerView: 3.5,
                },
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    setupCollectionTabs();
    setupProductHighlight();
    setupReviewsSwiper();
    setupMainBanner();
    setupStoresSwiper();
});